export const apiServer = process.env.VUE_APP_API_URI;
export const apiKeyMaps = "AIzaSyA6HMe4l770I-piy4a9b6FYWybU0v93ORs"
export const orderOrigin = "PICKO_WEB"
export const taxRate = 0.21

